var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video__container"},[(_vm.loading)?_c('vimeo-player',{ref:"player",staticClass:"embed-responsive",attrs:{"controls":_vm.contr,"video-id":_vm.id,"options":_vm.options}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }